import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const HitSummary = ({ data }) => {
  return (
    <StyledDiv>
      <div className="high">
        <span /> {data?.High || 0} High
      </div>
      <div className="good">
        <span /> {data?.Good || data?.Medium || 0} Good
      </div>
      <div className="low">
        <span /> {data?.Low || 0} Low
      </div>
    </StyledDiv>
  );
};

const StyledDiv = styled.div`
  width: 68px;
  div {
    line-height: 14px;
  }

  .high {
    color: #df6057;
    span {
      background-color: #df6057;
    }
  }

  .good {
    color: #e29840;
    span {
      background-color: #e29840;
    }
  }

  .low {
    color: #71c969;
    span {
      background-color: #71c969;
    }
  }

  span {
    height: 7px;
    width: 7px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 4px;
  }
`;

HitSummary.propTypes = {
  data: PropTypes.object
};

export default HitSummary;
